module.exports = "dist/8153acffe183d53ae7dece07dc722f1d.svg";